import type { NoCommentMeetingParticipant, OpinionParticipant } from "@sgdf/client";

export function internFilter(participant: NoCommentMeetingParticipant | OpinionParticipant) {
  return participant.role.intranet_id === 0 && ("hidden" in participant ? !participant.hidden : true);
}

export function supervisorFilter(participant: NoCommentMeetingParticipant) {
  return participant.role.intranet_id !== 0 && !participant.hidden;
}
